import { z } from 'zod';
/** Límites de una importación de clientes o productos. */
export const IMPORT_MAX_ROWS = 5000;
export const IMPORT_MAX_BYTES = 5 * 1024 * 1024;
/** El catálogo CABYS oficial es mucho más grande: tiene sus propios límites. */
export const CABYS_IMPORT_MAX_ROWS = 200_000;
export const CABYS_IMPORT_MAX_BYTES = 20 * 1024 * 1024;
const flag = z
    .union([z.boolean(), z.enum(['true', 'false', '1', '0'])])
    .transform((v) => v === true || v === 'true' || v === '1')
    .default(false);
/** Opciones al confirmar (llegan como campos de texto del formulario multipart). */
export const importCommitOptions = z.object({
    /** Actualizar los registros existentes (misma identificación o código) en vez de omitirlos. */
    updateExisting: flag,
    /** Crear las categorías que falten (productos). */
    createCategories: flag,
});
//# sourceMappingURL=import-export.js.map